export const WEEK_VIEW_SELECTED_PLACES = 'userschedule:selected-places';
export const WEEK_VIEW_SELECTED_TENANT = 'userschedule:selected-tenant';
export const USER_AZURE_ID = 'user:aaid';
export const PEOPLE_SELECTED_LOCATION = 'compareschedules:selected-location';
